import { type Icon } from "@chakra-ui/react";
import {
  BrazeIcon,
  GoogleAdsIcon,
  TikTokIcon,
  LinkedinCircleIcon,
  IterableIcon,
  SalesforceIcon,
  HubspotIcon,
  MetaIcon,
  TradeDeskIcon,
  InsiderIcon,
  ActiveCampaignIcon,
  IntercomIcon,
} from "ui/icons/integrations";
import { MapIcon, MinusCircleIcon, PersonWithCheckIcon, SendIcon, TargetIcon, TrendIcon } from "ui/icons";
import { integrationsCount } from "../../../constants/integrations";

export type SliderCardProps = {
  icon: { bgColor: string; color: string; icon: typeof Icon };
  title: string;
  description: string;
  integrations: Array<{ name: string; icon: typeof Icon }>;
  integrationsDescription: string;
};

export const sliderCards: SliderCardProps[] = [
  {
    icon: { bgColor: "new.violet.700", color: "new.violet.150", icon: TargetIcon },
    title: "Audience targeting",
    description: "Target users on any channel",
    integrations: [
      { name: "Google Ads", icon: GoogleAdsIcon },
      { name: "Meta", icon: MetaIcon },
      { name: "TikTok", icon: TikTokIcon },
      { name: "The Trade Desk", icon: TradeDeskIcon },
      { name: "LinkedIn", icon: LinkedinCircleIcon },
    ],
    integrationsDescription: "+40 ad platforms",
  },
  {
    icon: { bgColor: "new.red.500", color: "new.red.150", icon: MinusCircleIcon },
    title: "Audience suppression",
    description: "Reduce wasted spend and touchpoints",
    integrations: [
      { name: "HubSpot", icon: HubspotIcon },
      { name: "Google Ads", icon: GoogleAdsIcon },
      { name: "Meta", icon: MetaIcon },
      { name: "Salesforce", icon: SalesforceIcon },
      { name: "TikTok", icon: TikTokIcon },
    ],
    integrationsDescription: `+${integrationsCount} marketing tools`,
  },
  {
    icon: { bgColor: "new.green.500", color: "new.green.50", icon: TrendIcon },
    title: "Conversion uploads",
    description: "Send better signals to ad platforms",
    integrations: [
      { name: "Google Ads", icon: GoogleAdsIcon },
      { name: "Meta", icon: MetaIcon },
      { name: "TikTok", icon: TikTokIcon },
      { name: "The Trade Desk", icon: TradeDeskIcon },
      { name: "LinkedIn", icon: LinkedinCircleIcon },
    ],
    integrationsDescription: "+40 ad platforms",
  },
  {
    icon: { bgColor: "new.yellow.300", color: "new.yellow.700", icon: PersonWithCheckIcon },
    title: "Profile enrichment",
    description: "Keep profiles complete and up to date",
    integrations: [
      { name: "Salesforce", icon: SalesforceIcon },
      { name: "HubSpot", icon: HubspotIcon },
      { name: "Insider", icon: InsiderIcon },
      { name: "ActiveCampaign", icon: ActiveCampaignIcon },
      { name: "Intercom", icon: IntercomIcon },
    ],
    integrationsDescription: "+35 CRM and sales tools",
  },
  {
    icon: { bgColor: "new.green.300", color: "new.green.700", icon: MapIcon },
    title: "Journey orchestration",
    description: "Serve the best experience every time",
    integrations: [
      { name: "Iterable", icon: IterableIcon },
      { name: "Google Ads", icon: GoogleAdsIcon },
      { name: "Salesforce", icon: SalesforceIcon },
      { name: "HubSpot", icon: HubspotIcon },
      { name: "Meta", icon: MetaIcon },
    ],
    integrationsDescription: `+${integrationsCount} marketing tools`,
  },
  {
    icon: { bgColor: "new.blue.500", color: "new.blue.150", icon: SendIcon },
    title: "Email personalization",
    description: "Send the right message at the right time",
    integrations: [
      { name: "Iterable", icon: IterableIcon },
      { name: "Braze", icon: BrazeIcon },
      { name: "Salesforce", icon: SalesforceIcon },
      { name: "HubSpot", icon: HubspotIcon },
    ],
    integrationsDescription: `+${integrationsCount} marketing tools`,
  },
];
